export const getEpisodeText = (episode: { title: string; number: number }): string =>
    `${episode.number} - ${episode.title}`;
